import React from 'react';
import * as R from 'ramda';
import { DesktopTimePicker } from '@mui/x-date-pickers/DesktopTimePicker';
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// ui
import { Box } from '../../ui';
//////////////////////////////////////////////////

export const getTimePickerValue = (value) => {
  if (G.isNilOrEmpty(value)) return null;

  const dateTime = G.createTodayLocalDateTimeString(GC.DEFAULT_DATE_FORMAT, value);

  return G.isValidDate(dateTime) ? G.getNewDate(dateTime) : null;
};

export const TimePickerMui = ({
  m,
  value,
  label,
  width,
  disabled,
  onChange,
  ariaLabel,
  wrapperWidth,
  inputSettings = {},
  isClearable = true,
  inputReadOnly = true,
  disablePortal = false,
  placeholder = G.getWindowLocale('titles:select-time', 'Select Time'),
}) => {
  const format = G.getDateTimeFormatFromConfig('time');

  const handleChange = (date) => {
    if (R.isNil(date)) return onChange(null);

    if (G.isValidDate(date)) onChange(G.getLocalTimeFromDate(date));
  };

  return (
    <Box m={m} width={wrapperWidth}>
      <DesktopTimePicker
        ampm={R.equals(format, GC.DEFAULT_TIME_FORMAT)}
        value={getTimePickerValue(value)}
        disabled={disabled}
        onChange={handleChange}
        format={format}
        minutesStep={1}
        viewRenderers={{
          hours: renderTimeViewClock,
          minutes: renderTimeViewClock,
          seconds: renderTimeViewClock,
        }}
        slotProps={{
          actionBar: G.ifElse(isClearable, { actions: ['clear'] }),
          popper: { disablePortal },
          textField: {
            label,
            placeholder,
            size: 'small',
            inputProps: {
              readOnly: inputReadOnly,
              'aria-label': R.or(ariaLabel, R.or(label, placeholder)),
            },
            sx: {
              width,
              '.MuiInputBase-root': {
                height: 30,
                background: 'white',
                lineHeight: 'unset',
              },
              '.MuiOutlinedInput-input': {
                fontSize: 12,
                padding: '5px 0px 5px 8px',
              },
              ...inputSettings,
            },
          },
        }}
      />
    </Box>
  );
};
